"use strict";
/**
 * @module Services.RemoteServers
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * The response of RemoteServers CHECK_REMOTE_SERVER service
 */
var CheckRemoteServerResult = /** @class */ (function () {
    /**
     * Create a new CheckRemoteServerResult instance
     *
     * @param status  the remote server status
     */
    function CheckRemoteServerResult(status) {
        this.status = status;
    }
    return CheckRemoteServerResult;
}());
exports.CheckRemoteServerResult = CheckRemoteServerResult;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/remote-servers/check-remote-server-result.js
// module id = 1281
// module chunks = 1